import * as angular from "angular";
import * as _ from "lodash";
import {AnalyticsService} from "./analytics-service.service";

export class BringozToastService {

  defaults = {
    position: 'top right', // 'top center'
    delay: 8000, //mili.
    theme: 'success'
  };

  themes = {
    success: 'md-success-toast-theme',
    error: 'md-error-toast-theme',
    info: 'md-info-toast-theme',
    warning: 'md-warning-toast-theme'
  };

  constructor(private $mdToast, private $translate, private analyticsService: AnalyticsService, private Heap) {
  }

  success(message?, replaceObject?, actionName?, delay?, position?, containerId?) {
    return this.show('success', message, replaceObject, actionName, delay, position, containerId);
  }

  error(message?, replaceObject?, actionName?, delay?, position?, containerId?) {
    // if (!actionName) {
    //     actionName = 'Retry';
    // }
    // this.Heap.track('Error');
    // this.analyticsService.trackException(message.body, false);
    return this.show('error', message, replaceObject, actionName, delay, position, containerId);
  }

  info(message?, replaceObject?, actionName?, delay?, position?, containerId?) {
    return this.show('info', message, replaceObject, actionName, delay, position, containerId);
  }

  warning(message?, replaceObject?, actionName?, delay?, position?, containerId?) {
    return this.show('warning', message, replaceObject, actionName, delay, position, containerId);
  }

  // ******************************
  //        Private methods
  // ******************************

  private show(toastType, message, replaceObject, action, delay, position, containerId) {

    let theme = this.themes[toastType] || this.defaults.theme;

    return this.$mdToast.show({
      template:
        '<md-toast ng-class="vm.theme">'
        + '<bringoz-toast class="md-toast-content" details="vm.details" body="vm.body" message="vm.message" '
        + 'type="vm.type" action="vm.action" replace-object="vm.replaceObject"></bringoz-toast>'
        + '</md-toast>',
      hideDelay: delay || this.defaults.delay,
      position: position || this.defaults.position,
      locals: {
        theme: theme,
        type: toastType,
        replaceObject: replaceObject,
        details: _.get(message, 'details'),
        body: _.get(message, 'body'),
        message: _.get(message, 'message'),
        action: action
      },
      controllerAs: 'vm',
      controller: function () {
      },
      toastClass: 'bringoz-toast-container',
      autoWrap: false,
      bindToController: true,
      parent: containerId ? document.querySelectorAll('#' + containerId) : null

    });
  }
}


angular
  .module('bringoz.admin.commons')
  .service('bringozToastService', BringozToastService);
